import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import styled from 'styled-components';
import BRAND from "../../brand";

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: ${props => props.$background};
    z-index: 100000;
`;

// While a solid loader is up the page has a theme-color: the iOS app goes full screen behind the status bar
// (see SafeAreaContainerViewController), browsers tint their bars. Removed a tick later, so going from one
// loader to the next (app opening -> session check) keeps it.
let themeColorRemoval = null
const setThemeColor = (color) => {
    clearTimeout(themeColorRemoval)
    let meta = document.querySelector('meta[name="theme-color"]')
    if (!meta) meta = document.head.appendChild(Object.assign(document.createElement('meta'), { name: 'theme-color' }))
    meta.content = color
    return () => { themeColorRemoval = setTimeout(() => meta.remove(), 100) }
}

// solid: full page loader while the app or a screen opens, otherwise a veil over the screen during an action.
// Brands with a splash: the solid loader looks like the native splash (same image), spinner below the logo
export default function MainLoader ({solid = false}) {
    const splash = solid && BRAND.splash
    const background = splash ? `${BRAND.splashColor} url(${BRAND.splash}) center / cover no-repeat` : (solid ? '#FFFFFF' : '#37373780')

    useEffect(() => {
        if (solid) return setThemeColor(splash ? BRAND.splashColor : '#FFFFFF')
    }, [solid, splash])

    return (
        <Container id="pageLoader" $background={background}>
            {splash ?
                <Spinner style={{width:'2.5rem', height:'2.5rem', color:'#FFFFFF', marginTop:'30vh'}}/>
            :
                <Spinner className="mx-auto" style={{width:'4rem', height:'4rem', color:"var(--primary-color)"}}/>
            }
        </Container>
    )
}
